<template>
    <div>
        <p>
            {{ cCommodityName }}
        </p>

        <p v-if="cGoodsStatusName">
            {{ cGoodsStatusName }}
        </p>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const cCommodityName = computed(() => params?.value?.data?.commodityName)
const cGoodsStatusName = computed(() => {
  const goodsStatusName = params?.value?.data?.goodsStatusName
  if (!goodsStatusName) {
    return ''
  }

  if (goodsStatusName === 'Hàng thường') {
    return ''
  }

  return goodsStatusName
})
</script>
